import fetchAPI from '../utils/service';

function getVideosRequest() {
  return {
    type: 'GET_VIDEOS_REQUEST',
  };
}
function getVideosSuccess(payload) {
  return {
    type: 'GET_VIDEOS_SUCCESS',
    payload,
  };
}
function getVideosFailure() {
  return {
    type: 'GET_VIDEOS_FAILURE',
  };
}

function getVideos() {
  return async (dispatch) => {
    await dispatch(getVideosRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/video/list',
      });
      if (res.status === 200) {
        await dispatch(getVideosSuccess(res.data));
      } else {
        await dispatch(getVideosFailure());
      }
    } catch (error) {
      await dispatch(getVideosFailure());
    }
  };
}

function getVideoInfoRequest() {
  return {
    type: 'GET_VIDEO_INFO_REQUEST',
  };
}
function getVideoInfoSuccess(payload) {
  return {
    type: 'GET_VIDEO_INFO_SUCCESS',
    payload,
  };
}
function getVideoInfoFailure() {
  return {
    type: 'GET_VIDEO_INFO_FAILURE',
  };
}

function getVideoInfo(url) {
  return async (dispatch) => {
    await dispatch(getVideoInfoRequest());
    try {
      const res = await fetchAPI({
        endpoints: `/video/info/${url}`,
      });
      if (res.status === 200) {
        await dispatch(getVideoInfoSuccess(res.data));
      } else {
        await dispatch(getVideoInfoFailure());
      }
    } catch (error) {
      await dispatch(getVideoInfoFailure());
    }
  };
}

function createVideoRequest() {
  return {
    type: 'CREATE_VIDEO_REQUEST',
  };
}
function createVideoSuccess(data) {
  return {
    type: 'CREATE_VIDEO_SUCCESS',
    payload: {
      data,
    },
  };
}
function createVideoFailure() {
  return {
    type: 'CREATE_VIDEO_FAILURE',
  };
}

function createVideo({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(createVideoRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/video',
      });
      if (res.status === 201) {
        await dispatch(createVideoSuccess(res.data));
        await response.success();
      } else {
        await dispatch(createVideoFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(createVideoFailure());
      await response.failure();
    }
  };
}

function editVideoRequest() {
  return {
    type: 'EDIT_VIDEO_REQUEST',
  };
}
function editVideoSuccess(data, _id) {
  return {
    type: 'EDIT_VIDEO_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function editVideoFailure() {
  return {
    type: 'EDIT_VIDEO_FAILURE',
  };
}

function editVideo({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(editVideoRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/video/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(editVideoSuccess(res.data, _id));
        await response.success();
      } else {
        await dispatch(editVideoFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(editVideoFailure());
      await response.failure();
    }
  };
}

function deleteVideoRequest() {
  return {
    type: 'DELETE_VIDEO_REQUEST',
  };
}
function deleteVideoSuccess(_id) {
  return {
    type: 'DELETE_VIDEO_SUCCESS',
    payload: {
      _id,
    },
  };
}
function deleteVideoFailure() {
  return {
    type: 'DELETE_VIDEO_FAILURE',
  };
}

function deleteVideo({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(deleteVideoRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/video/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(deleteVideoSuccess(_id));
        await response.success();
      } else {
        await dispatch(deleteVideoFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(deleteVideoFailure());
      await response.failure();
    }
  };
}

export {
  getVideos,
  createVideo,
  editVideo,
  deleteVideo,
  getVideoInfo,
};



// WEBPACK FOOTER //
// ./src/actions/video.js